export default "__VITE_ASSET__DHsMQnRD__"